import { parseAppMode } from "./app-mode";
import { parseMemberContext } from "./member-context";
import { parseRoles } from "./roles";
import { expectNullable, expectRecord, expectString } from "./schema";
import { parseTenantContext } from "./tenant-context";
export function parseSessionResponse(value, path = "session") {
    const record = expectRecord(value, path);
    return {
        platformUserId: expectString(record.platformUserId, `${path}.platformUserId`),
        tenant: parseTenantContext(record.tenant, `${path}.tenant`),
        roles: parseRoles(record.roles, `${path}.roles`),
        member: expectNullable(record.member, parseMemberContext, `${path}.member`),
        appMode: expectNullable(record.appMode, parseAppMode, `${path}.appMode`),
        entryPath: expectString(record.entryPath, `${path}.entryPath`)
    };
}
export function parseLineLoginRequest(value, path = "lineLoginRequest") {
    const record = expectRecord(value, path);
    return {
        tenantSlug: expectString(record.tenantSlug, `${path}.tenantSlug`),
        idToken: expectString(record.idToken, `${path}.idToken`)
    };
}
